import apiConfig from "../../../config/api";
import trace from "../../../helpers/trace";
import store from "../../../config/store";
import { ErrorSnacktOpen } from "../../ErrorSnack/actions";

// //////////////////
// Action Creators //
// //////////////////

export const Loading = (loading) => ({
  type: "FILTROBUSQUEDARC/LOADING",
  loading,
});

export const CargarRecargosConvenidos = (recargosConvenidos) => ({
  type: "FILTROBUSQUEDARC/CARGA_RECARGOS_CONVENIDOS",
  recargosConvenidos,
});

export const OpenFiltroBusquedaDetalle = (modalFiltroBusquedaDetalle) => ({
  type: "FILTROBUSQUEDARC/MODAL_FILTRO_BUSQUEDA_DETALLE",
  modalFiltroBusquedaDetalle,
});

export const GuardarFiltrosBusqueda = (filtros) => ({
  type: "FILTROBUSQUEDARC/GUARDAR_FILTROS_BUSQUEDA",
  filtros,
});

export const ShowTecniquesInExcep = modalShowTecniques => ({
  type: "FILTROBUSQUEDARC/SHOW_TECNIQUES_EXCEP",
  modalShowTecniques,
});

export const UpdateDetailTecniquesForModal = detailTecniques => ({
  type: 'FILTROBUSQUEDARC/UPDATE_DETAIL_TECNIQUES_MODAL',
  detailTecniques,
});

export const SetTipoPrestacion = tipoPrestacion => ({
  type: 'FILTROBUSQUEDARC/SET_TIPO_PRESTACION',
  tipoPrestacion,
});

// ////////////////////////
// Action Orchestrators  //
// ////////////////////////

export const ObtenerRecargosConvenidos = (filtroB) => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    RutInstitucion: globalState.rutInstitucion,
    RutArancel: filtroB.RutArancel,
    CentroAtencion: filtroB.CentroAtencion,
    GrupoPrestacion: filtroB.GrupoPrestacion === 0 ? null : filtroB.GrupoPrestacion,
    Isapre: globalState.isapre,
  };

  dispatch(GuardarFiltrosBusqueda(params));

  params.token = globalState.token;

  fetch(`${apiConfig.apiUri}/v1/recargoconvenios/search/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("ObtenerRecargosConvenidos", json);
        dispatch(SetTipoPrestacion(filtroB.GrupoPrestacion));
        dispatch(CargarRecargosConvenidos(json));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("ObtenerRecargosConvenidos", error);
      dispatch(ErrorSnacktOpen(
        "Error al obtener recargos convenidos:",
        error,
      ));
    });
};
